goog.provide("shadow.js.shim.module$$mui$icons_material$CancelRounded");
goog.provide("module$shadow_js_shim_module$$mui$icons_material$CancelRounded");
shadow.js.shim.module$$mui$icons_material$CancelRounded = shadow.js.nativeProvides["@mui/icons-material/CancelRounded"] = shadow$bridge("@mui/icons-material/CancelRounded");
module$shadow_js_shim_module$$mui$icons_material$CancelRounded.default = shadow.js.shim.module$$mui$icons_material$CancelRounded;
